/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class Provider implements Serializable<Provider> {

    password: string;
    providerId: string;                     // “AWS-COGNITO-IDENTITY-B”,
    firstName: string;             // "John"
    lastName: string;              // "Doe"
    approvedProvider: boolean;      // "Optional, for provider accounts Default value= false"
    providerIdentity: string;      // "Optional, for provider accounts"
    roles: string[] = [];           // "Optional, for ECV staff. Default value = empty array"

    type: string;
    city: string;
    contact: string;
    middleInitials: string;
    numberOfChildren: string;
    profession: string;
    state: string;
    superadmin: boolean;
    id: number;
    deserialize(input) {
        (input.id) && (this.id = input.id);
        (input.password) && (this.password = input.password);
        (input.firstName) && (this.firstName = input.firstName);
        (input.lastName) && (this.lastName = input.lastName);
        (input.approvedProvider) && (this.approvedProvider = input.approvedProvider);
        (input.providerIdentity) && (this.providerIdentity = input.providerIdentity);
        (input.type) && (this.type = input.type);

        (input.city) && (this.city = input.city);
        (input.contact) && (this.contact = input.contact);
        (input.middleInitials) && (this.middleInitials = input.middleInitials);
        (input.numberOfChildren) && (this.numberOfChildren = input.numberOfChildren);
        (input.profession) && (this.profession = input.profession);
        (input.state) && (this.state = input.state);
        (input.superadmin) && (this.superadmin = input.superadmin);

        if (!!input.roles) {
            for (var i = 0; i < input.roles.length; i++) {
                var role = input.roles[i];
                this.roles[i] = role;
            }
        }

        return this;
    }

    constructor() {
    }
}
